var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.model)?_c('div',{staticClass:"bar-chart",style:({width: `100%`, height:`${(_vm.model.max / _vm.model.interval + 1) * 50}px`}),attrs:{"id":_vm.chartID}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }